import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { decode } from 'he';
import { OnlyFansVaultAlbums } from '../../hooks/useSubscriberVaultAlbums';

export default function AlbumSelect({
    vaultAlbum,
    sortedAlbums,
    isLoading,
    handleAlbumChange,
    selectSize,
}: {
    vaultAlbum: number;
    sortedAlbums: OnlyFansVaultAlbums.List[] | undefined;
    isLoading: boolean;
    handleAlbumChange: (e: SelectChangeEvent<any>) => void;
    selectSize: 'small' | 'medium';
}) {
    return (
        <FormControl fullWidth sx={{ mt: 0, mb: 0 }}>
            <InputLabel id="vaultAlbum">Vault Album</InputLabel>
            <Select
                labelId="vaultAlbum"
                defaultValue={0}
                value={vaultAlbum}
                disabled={isLoading}
                onChange={handleAlbumChange}
                fullWidth
                size={selectSize}
                label="Vault Album"
                error={vaultAlbum === -1}
            >
                {isLoading && (
                    <MenuItem value={0} disabled>
                        {`Loading Albums... ${sortedAlbums && sortedAlbums.length > 0 ? `(${sortedAlbums.length.toLocaleString()})` : ''}`}
                    </MenuItem>
                )}
                {!isLoading && (
                    <MenuItem value={0}>
                        <strong>All</strong>
                    </MenuItem>
                )}

                {!isLoading &&
                    sortedAlbums &&
                    sortedAlbums.map(album => (
                        <MenuItem value={album.id} key={album.id}>
                            <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{decode(album.name)}</div>
                        </MenuItem>
                    ))}
            </Select>
        </FormControl>
    );
}
